import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import FolderIcon from '@mui/icons-material/Folder';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const FolderFormatter = ({ row }) => {
  const folder = row.folder || '';
  if (!folder) return <span style={{ color: '#aaa' }}>—</span>;

  const parts = folder.split('/').filter(Boolean);
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <FolderIcon style={{ color: '#ff9800', fontSize: 18, marginRight: 4 }} />
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {i > 0 && <ChevronRightIcon style={{ color: '#bbb', fontSize: 16 }} />}
          <span style={{ fontWeight: i === parts.length - 1 ? 700 : 400, fontSize: 13, color: i === parts.length - 1 ? '#222' : '#666' }}>
            {part}
          </span>
        </React.Fragment>
      ))}
    </span>
  );
};

const FolderTypeProvider = props => <DataTypeProvider formatterComponent={FolderFormatter} {...props} />;

export default FolderTypeProvider;
